import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isAuthenticated } from "./authCheck";

const PUBLIC_ROUTES = ["/authentication/sign-in", "/authentication/sign-up"];

const AuthWrapper = ({ children }) => {
  const [authStatus, setAuthStatus] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      if (PUBLIC_ROUTES.includes(location.pathname)) {
        setAuthStatus(true);
        return;
      }

      const result = await isAuthenticated();
      setAuthStatus(result);

      if (!result) {
        window.location.href = "/authentication/sign-in";
      }
    };

    checkAuth();
  }, [location.pathname]); // Løper på endring av ruten

  if (authStatus === null) {
    return <div>Loading...</div>;
  }

  return authStatus ? children : null;
};

export default AuthWrapper;
